export default __webpack_public_path__ + "static/media/GitHub-Mark-Light-120px-plus.e25eef4c.webp";